/* ======================================================================
   finalizacao.js — Robusta PDP
   Interações das novas seções de produto. Carregado depois de theme.js
   (ver layout/theme.liquid).
====================================================================== */
(function () {
  'use strict';

  /* ============================================================
     A. Passo a Passo — carrossel (product-how-to-media.liquid)
     Scroll horizontal com setas + expand/collapse por passo.
  ============================================================ */
  function initStepsCarousel(root) {
    var track = root.querySelector('[data-stepscarousel-track]');
    var list = root.querySelector('[data-stepscarousel-list]');
    if (!track || !list) return;

    var items = list.querySelectorAll('[data-stepscarousel-item]');
    var prev = root.querySelector('[data-stepscarousel-prev]');
    var next = root.querySelector('[data-stepscarousel-next]');

    function getStep() {
      var first = items[0];
      var second = items[1];
      if (!first) return 0;
      if (second) return second.offsetLeft - first.offsetLeft;
      return first.getBoundingClientRect().width + 24;
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    var scrollTicking = false;
    track.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        updateNav();
        scrollTicking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', updateNav);
    updateNav();

    // Expand/collapse: nome do passo + chevron abrindo a descrição completa
    items.forEach(function (item) {
      var toggle = item.querySelector('[data-stepscarousel-toggle]');
      var body = item.querySelector('[data-stepscarousel-body]');
      if (!toggle || !body || toggle.tagName !== 'BUTTON') return;

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          body.style.maxHeight = '0px';
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.querySelectorAll('[data-stepscarousel-section]').forEach(initStepsCarousel);


  /* ============================================================
     B. Composição traduzida (product-composition.liquid)
     Expandir/recolher texto longo + auto-scroll/realce vindo de QR Code.
  ============================================================ */
  function initComposition(root) {
    var body = root.querySelector('[data-composition-body]');
    var toggle = root.querySelector('[data-composition-toggle]');
    var toggleLabel = root.querySelector('[data-composition-toggle-label]');

    function expand() {
      if (!body) return;
      body.classList.add('is-expanded');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        if (toggleLabel) toggleLabel.textContent = 'Ver menos';
      }
    }

    function collapse() {
      if (!body) return;
      body.classList.remove('is-expanded');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (toggleLabel) toggleLabel.textContent = 'Ver composição completa';
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) { collapse(); } else { expand(); }
      });
    }

    function checkDeepLink() {
      var params = null;
      try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
      var isQr = !!(params && params.get('qr') === '1');
      // O ID da âncora é configurável na seção (usado no QR Code do rótulo)
      var anchorId = root.getAttribute('data-anchor-id') || root.id || 'composicao';
      var isHash = window.location.hash === '#' + anchorId;
      if (!isQr && !isHash) return;

      expand();
      window.setTimeout(function () {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        root.classList.add('is-highlighted');
        window.setTimeout(function () {
          root.classList.remove('is-highlighted');
        }, 2200);
      }, 150);
    }

    checkDeepLink();
    window.addEventListener('hashchange', checkDeepLink);
  }

  document.querySelectorAll('[data-composition-section]').forEach(initComposition);


  /* ============================================================
     C. Aprenda Mais — Vídeo (product-learn-video.liquid)
     Facade do YouTube: troca a thumbnail pelo iframe ao clicar em play.
  ============================================================ */
  function initLearnVideo(root) {
    var media = root.querySelector('[data-learnvideo-media]');
    var playBtn = root.querySelector('[data-learnvideo-play]');
    if (!media || !playBtn) return;

    playBtn.addEventListener('click', function () {
      var id = media.getAttribute('data-youtube-id');
      if (!id) return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = 'Vídeo';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.frameBorder = '0';

      media.innerHTML = '';
      media.appendChild(iframe);
    });
  }

  document.querySelectorAll('[data-learnvideo-section]').forEach(initLearnVideo);


  /* ============================================================
     E. Perguntas Frequentes (product-faq.liquid)
     Acordeão — apenas uma pergunta aberta por vez.
  ============================================================ */
  function initFaq(root) {
    var items = root.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    function closeItem(item) {
      var q = item.querySelector('[data-faq-toggle]');
      var a = item.querySelector('[data-faq-answer]');
      if (q) q.setAttribute('aria-expanded', 'false');
      if (a) a.style.maxHeight = '0px';
    }

    function openItem(item) {
      var q = item.querySelector('[data-faq-toggle]');
      var a = item.querySelector('[data-faq-answer]');
      if (q) q.setAttribute('aria-expanded', 'true');
      if (a) a.style.maxHeight = a.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        items.forEach(closeItem);
        if (!isOpen) openItem(item);
      });
    });

    // Recalcula a altura do item aberto ao redimensionar a janela
    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        var toggle = item.querySelector('[data-faq-toggle]');
        if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
          openItem(item);
        }
      });
    });
  }

  document.querySelectorAll('[data-faq-section]').forEach(initFaq);


  /* ============================================================
     F. LP do Tônico (sections/page-lp-tonico.liquid)
     Animações de entrada na viewport + acordeão da composição INCI.
  ============================================================ */
  (function initLandingPage() {
    var root = document.querySelector('[data-lp]');
    if (!root) return;

    /* ── Entrada dos elementos ao aparecer na tela ── */
    var animated = root.querySelectorAll('[data-lp-anim]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    if (!animated.length) { /* nada a animar */ }
    else if (reduce || designMode || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Escalona itens irmãos para a entrada parecer encadeada
          var siblings = el.parentNode ? el.parentNode.querySelectorAll('[data-lp-anim]') : [];
          var idx = Array.prototype.indexOf.call(siblings, el);
          el.style.transitionDelay = (Math.max(0, idx) % 6) * 0.07 + 's';
          el.classList.add('is-visible');
          observer.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      animated.forEach(function (el) { observer.observe(el); });

      // Rede de segurança: o que já estiver na tela no load aparece de imediato
      window.setTimeout(function () {
        animated.forEach(function (el) {
          if (el.classList.contains('is-visible')) return;
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
        });
      }, 400);
    }

    /* ── Acordeão da composição completa (INCI) ── */
    root.querySelectorAll('[data-lp-accordion]').forEach(function (acc) {
      var toggle = acc.querySelector('[data-lp-accordion-toggle]');
      var body = acc.querySelector('[data-lp-accordion-body]');
      if (!toggle || !body) return;

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        body.style.maxHeight = open ? '0px' : body.scrollHeight + 'px';
      });

      window.addEventListener('resize', function () {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  })();

})();


/* ======================================================================
   finalizacao.js — Robusta HOME / HEADER / CART
   Anexado após o bloco de PDP acima (não alterado). Cobre: barra de
   aviso, menu mobile, abertura do carrinho pelo cabeçalho, o motor
   window.RobustaCart (popup + página /cart) e o carrossel de avisos
   do carrinho. Carregado depois de assets/theme.js (ver layout/theme.liquid).
====================================================================== */
(function () {
  'use strict';

  /* ============================================================
     G. Barra de aviso (sections/announcement-bar.liquid)
     Rotaciona as mensagens e recolhe discretamente ao rolar a página.
  ============================================================ */
  /**
   * Mede a pilha do topo (faixa de avisos + cabeçalho) e publica a altura em
   * --header-stack-h. O hero da home usa essa variável como padding-top, então
   * nunca fica escondido atrás da pilha nem sobra espaço em branco.
   */
  var headerStackEl = document.querySelector('[data-header-stack]');
  function syncHeaderStackHeight() {
    var ann = document.querySelector('[data-announcement-bar]');
    var annH = (ann && !ann.classList.contains('is-hidden')) ? (ann.offsetHeight || 0) : 0;
    document.documentElement.style.setProperty('--ann-bar-h', annH + 'px');
    if (!headerStackEl) return;
    document.documentElement.style.setProperty('--header-stack-h', (headerStackEl.offsetHeight || 0) + 'px');
  }
  window.RobustaHeader = { sync: syncHeaderStackHeight };

  function initAnnouncementBar(root) {
    var items = root.querySelectorAll('[data-announcement-track] .announcement-bar__item');
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;

    if (items.length > 1) {
      var current = 0;
      window.setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, speed);
    }

    /**
     * Histerese proposital.
     *
     * Antes o limiar era 24px — MENOR que a altura da própria faixa (36px).
     * Fora da home a pilha do topo está em fluxo, então recolher a faixa tira
     * 36px de altura do documento; o navegador reancora o scroll, a posição
     * cai abaixo do limiar, a faixa volta, e o ciclo se repete — o tremor que
     * aparecia por volta dos 16px de rolagem.
     *
     * Com esconder>90 e mostrar<30, a folga (60px) é maior que a altura da
     * faixa, então nenhum reajuste de scroll consegue cruzar o limiar oposto.
     */
    var HIDE_AT = 90;
    var SHOW_AT = 30;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      if (y > HIDE_AT) {
        root.classList.add('is-hidden');
      } else if (y < SHOW_AT) {
        root.classList.remove('is-hidden');
      }
      syncHeaderStackHeight();
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  document.querySelectorAll('[data-announcement-bar]').forEach(initAnnouncementBar);

  window.addEventListener('resize', syncHeaderStackHeight);
  window.addEventListener('load', syncHeaderStackHeight);
  // O cabeçalho encolhe no scroll (transition de 0.3s): remede ao fim da animação
  if (headerStackEl) {
    headerStackEl.addEventListener('transitionend', syncHeaderStackHeight);
    if (typeof window.ResizeObserver === 'function') {
      new window.ResizeObserver(syncHeaderStackHeight).observe(headerStackEl);
    }
  }
  syncHeaderStackHeight();


  /* ============================================================
     H. Menu mobile (sections/header.liquid)
     Abre/fecha o drawer lateral via hambúrguer, overlay ou tecla ESC.
  ============================================================ */
  (function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var overlayEl = document.querySelector('.mobile-menu-overlay');
    var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
    if (!toggle || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      if (overlayEl) overlayEl.classList.add('is-open');
      document.body.classList.add('has-mobile-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      if (overlayEl) overlayEl.classList.remove('is-open');
      document.body.classList.remove('has-mobile-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) { closeMenu(); } else { openMenu(); }
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      }
    });

    // Fecha o drawer sempre que um link interno for acionado
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  })();


  /* ============================================================
     I. Carrinho do cabeçalho (sections/header.liquid)
     Intercepta o clique em [data-cart-open] e abre o popup do
     carrinho em vez de navegar direto para /cart, quando disponível.
  ============================================================ */
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (window.RobustaCart && typeof window.RobustaCart.open === 'function') {
        e.preventDefault();
        window.RobustaCart.open();
      } else if (typeof window.showCartPopup === 'function') {
        e.preventDefault();
        window.showCartPopup();
      }
      // Sem popup disponível: mantém a navegação padrão para /cart
    });
  });


  /* ============================================================
     J. Motor do carrinho — window.RobustaCart
     Compartilhado entre o popup criado em assets/theme.js e a página
     /cart (sections/main-cart.liquid). Não recria o que já existe em
     window.RobustaCart (ex.: .open, já definido pelo theme.js).
  ============================================================ */
  var FREE_SHIPPING_FALLBACK_THRESHOLD = 14990;
  var FREE_SHIPPING_FALLBACK_TEXT = 'Você ganhou frete grátis!';

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function getShippingConfig() {
    var ref = document.querySelector('[data-free-shipping-bar][data-threshold]');
    var threshold = ref ? parseInt(ref.getAttribute('data-threshold'), 10) : NaN;
    var reachedText = ref ? ref.getAttribute('data-reached-text') : '';
    if (!threshold || isNaN(threshold)) threshold = FREE_SHIPPING_FALLBACK_THRESHOLD;
    return {
      threshold: threshold,
      reachedText: reachedText || FREE_SHIPPING_FALLBACK_TEXT
    };
  }

  function renderShippingBars(cart) {
    var cfg = getShippingConfig();
    var remaining = Math.max(cfg.threshold - cart.total_price, 0);
    var pct = Math.min((cart.total_price / cfg.threshold) * 100, 100);
    var reached = cart.total_price >= cfg.threshold;

    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      bar.classList.add('cart-shipping-bar');
      var textHtml = reached
        ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + cfg.reachedText
        : 'Faltam <strong>' + formatMoney(remaining) + '</strong> para o frete grátis';
      bar.innerHTML =
        '<div class="cart-shipping-bar__track"><div class="cart-shipping-bar__fill" style="width:' + pct + '%"></div></div>' +
        '<p class="cart-shipping-bar__text' + (reached ? ' cart-shipping-bar__text--done' : '') + '">' + textHtml + '</p>';
    });
  }

  /* Marca oficial do Pix (o ícone anterior era um desenho genérico quebrado) */
  var PIX_ICON =
    '<svg class="cart-payment-appeals__pix" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" fill="currentColor" aria-hidden="true">' +
      '<path d="M242.4 240.24c-11.79 0-22.87-4.59-31.21-12.93l-45.08-45.07c-3.17-3.17-8.69-3.17-11.86 0l-45.24 45.24c-8.34 8.34-19.42 12.93-31.21 12.93h-8.9l57.1 57.1c17.84 17.84 46.76 17.84 64.6 0l57.26-57.26h-5.46zM77.8 71.63c11.79 0 22.87 4.59 31.21 12.93l45.24 45.24c3.27 3.27 8.59 3.27 11.86 0l45.08-45.07c8.34-8.34 19.42-12.93 31.21-12.93h5.46l-57.26-57.26c-17.84-17.84-46.76-17.84-64.6 0l-57.1 57.09h8.9z"/>' +
      '<path d="M297.34 123.7l-34.57-34.57c-.76.31-1.59.5-2.46.5h-15.9c-8.13 0-16.1 3.3-21.85 9.05l-45.08 45.07c-4.22 4.22-9.77 6.34-15.31 6.34s-11.09-2.11-15.31-6.33l-45.24-45.24c-5.75-5.75-13.72-9.05-21.85-9.05h-19.55c-.82 0-1.59-.19-2.31-.47l-34.7 34.7c-17.84 17.84-17.84 46.76 0 64.6l34.7 34.7c.72-.28 1.5-.47 2.31-.47h19.55c8.13 0 16.1-3.3 21.85-9.05l45.24-45.23c8.18-8.18 22.45-8.18 30.63 0l45.08 45.07c5.75 5.75 13.72 9.05 21.85 9.05h15.9c.87 0 1.69.19 2.46.5l34.57-34.57c17.84-17.84 17.84-46.76 0-64.6z"/>' +
    '</svg>';

  var CARD_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>';

  function ensurePaymentAppeals(container) {
    if (!container || container.children.length) return;
    var cfg = window.RobustaCartConfig || {};
    var installments = cfg.payInstallments || 'Parcelamento em até 6x s/ juros no cartão de crédito';
    var pix = cfg.payPix || '3% off no pix';
    container.innerHTML =
      '<p class="cart-payment-appeals__item">' + CARD_ICON + escapeHtml(installments) + '</p>' +
      '<p class="cart-payment-appeals__item">' + PIX_ICON + escapeHtml(pix) + '</p>';
  }

  function escapeHtml(str) {
    if (window.RobustaEscape) return window.RobustaEscape(str);
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function cdnImage(url, width) {
    if (window.RobustaCartImage) return window.RobustaCartImage(url, width);
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* ============================================================
     J1. Carrinho lateral — lista de itens
     Renderiza foto, título, variante, seletor de quantidade,
     remoção e total por linha a partir do JSON de /cart.js.
  ============================================================ */
  function renderCartDrawer(cart) {
    var list = document.querySelector('[data-cart-popup-items]');
    if (!list) return;

    if (!cart.items || cart.items.length === 0) {
      list.innerHTML =
        '<div class="cart-popup__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>' +
          '<p>Seu carrinho está vazio.</p>' +
          '<a class="cart-popup__empty-link" href="/collections/all">Ver todos os produtos</a>' +
        '</div>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var src = it.image || (it.featured_image && it.featured_image.url) || '';
        var img = src
          ? '<img class="cart-popup__item-img" src="' + escapeHtml(cdnImage(src, 160)) + '" alt="' + escapeHtml(it.product_title || '') + '" width="56" height="56" loading="lazy">'
          : '<span class="cart-popup__item-img cart-popup__item-img--empty" aria-hidden="true"></span>';

        var variant = '';
        if (it.variant_title && it.variant_title !== 'Default Title') {
          variant = '<span class="cart-popup__item-variant">' + escapeHtml(it.variant_title) + '</span>';
        }

        var key = escapeHtml(it.key);
        return '' +
          '<div class="cart-popup__item" data-drawer-row data-key="' + key + '">' +
            '<a class="cart-popup__item-media" href="' + escapeHtml(it.url || '#') + '">' + img + '</a>' +
            '<div class="cart-popup__item-info">' +
              '<a class="cart-popup__item-title" href="' + escapeHtml(it.url || '#') + '">' + escapeHtml(it.product_title || '') + '</a>' +
              variant +
              '<div class="cart-popup__item-controls">' +
                '<div class="cart-qty-mini">' +
                  '<button type="button" class="cart-qty-mini__btn" data-drawer-qty="-1" data-key="' + key + '" aria-label="Diminuir quantidade">&minus;</button>' +
                  '<span class="cart-qty-mini__value" data-drawer-qty-value>' + it.quantity + '</span>' +
                  '<button type="button" class="cart-qty-mini__btn" data-drawer-qty="1" data-key="' + key + '" aria-label="Aumentar quantidade">+</button>' +
                '</div>' +
                '<button type="button" class="cart-popup__item-remove" data-drawer-remove data-key="' + key + '" aria-label="Remover item">' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
            '<span class="cart-popup__item-price">' + formatMoney(it.final_line_price) + '</span>' +
          '</div>';
      }).join('');
    }

    var subtotal = document.querySelector('[data-cart-popup-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var foot = document.querySelector('.cart-popup__foot');
    if (foot) foot.classList.toggle('is-empty', !cart.items || cart.items.length === 0);
  }

  function updateHeaderBadge(count) {
    document.querySelectorAll('[data-cart-open]').forEach(function (link) {
      var badge = link.querySelector('.site-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
    });
  }

  function updateCartPageRows(cart) {
    var body = document.querySelector('[data-cart-items-body]');
    if (!body) return;

    if (cart.item_count === 0) {
      // Recarrega para exibir o estado de carrinho vazio já renderizado no liquid
      window.location.reload();
      return;
    }

    document.querySelectorAll('[data-cart-row]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (!item) {
        if (row.parentNode) row.parentNode.removeChild(row);
        return;
      }
      var qtyInput = row.querySelector('[data-cart-qty-input]');
      if (qtyInput) qtyInput.value = item.quantity;
      var lineTotal = row.querySelector('[data-cart-line-total]');
      if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price);
    });

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    var countEl = document.querySelector('[data-cart-item-count]');
    if (countEl) countEl.textContent = cart.item_count;
    var wordEl = document.querySelector('[data-cart-item-word]');
    if (wordEl) wordEl.textContent = cart.item_count === 1 ? 'item' : 'itens';
  }

  function refresh(cart) {
    if (!cart) return;
    updateHeaderBadge(cart.item_count);
    renderShippingBars(cart);
    ensurePaymentAppeals(document.querySelector('.cart-popup__payment-appeals'));
    renderCartDrawer(cart);
    renderAppliedDiscounts(cart);
    updateCartPageRows(cart);
  }

  /* Cupons aplicados — mostrado no carrinho lateral e na página do carrinho */
  function renderAppliedDiscounts(cart) {
    var discounts = cart.cart_level_discount_applications || [];
    document.querySelectorAll('[data-discount-applied]').forEach(function (list) {
      if (!discounts.length) {
        list.setAttribute('hidden', 'hidden');
        list.innerHTML = '';
        return;
      }
      list.removeAttribute('hidden');
      list.innerHTML = discounts.map(function (d) {
        return '<li><span>' + escapeHtml(d.title) + '</span><span>&minus; ' + formatMoney(d.total_allocated_amount) + '</span>' +
          '<button type="button" class="cart-discount__remove" data-discount-remove aria-label="Remover cupom">&times;</button></li>';
      }).join('');
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refresh(cart);
        return cart;
      });
  }

  function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code || '' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refresh(cart);
        return cart;
      });
  }

  window.RobustaCart = window.RobustaCart || {};
  if (typeof window.RobustaCart.open !== 'function') {
    window.RobustaCart.open = function () {
      if (typeof window.showCartPopup === 'function') { window.showCartPopup(); return; }
      window.location.href = '/cart';
    };
  }
  window.RobustaCart.formatMoney = formatMoney;
  window.RobustaCart.changeLine = changeLine;
  window.RobustaCart.applyDiscount = applyDiscount;
  window.RobustaCart.refresh = refresh;


  /* ============================================================
     K. Carrossel de avisos do carrinho (data-info-carousel)
     Usado na página /cart (sections/main-cart.liquid) e reaproveitado
     dentro do popup criado por assets/theme.js.
  ============================================================ */
  function initInfoCarousel(root) {
    var track = root.querySelector('[data-info-carousel-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.cart-info-carousel__slide');
    if (!slides.length) return;

    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === 0);
    });
    if (slides.length < 2) return;

    var current = 0;
    window.setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 4500);
  }

  document.querySelectorAll('[data-info-carousel]').forEach(initInfoCarousel);


  /* ============================================================
     L. Quantidade, remoção e cupom
     Vale para a página do carrinho (sections/main-cart.liquid) e para o
     carrinho lateral criado em assets/theme.js — os dois usam o mesmo motor.
  ============================================================ */

  /* ── Página do carrinho: steppers e remoção ── */
  (function initCartPage() {
    var page = document.querySelector('.cart-page');
    if (!page) return;

    page.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var incBtn = e.target.closest('[data-cart-qty-inc]');
      var decBtn = e.target.closest('[data-cart-qty-dec]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (incBtn || decBtn) {
        var btn = incBtn || decBtn;
        var key = btn.getAttribute('data-key');
        var row = btn.closest('[data-cart-row]');
        var input = row ? row.querySelector('[data-cart-qty-input]') : null;
        var current = input ? (parseInt(input.value, 10) || 1) : 1;
        var next = incBtn ? current + 1 : Math.max(current - 1, 0);
        if (input) input.value = next;
        changeLine(key, next);
        return;
      }

      if (removeBtn) {
        var removeKey = removeBtn.getAttribute('data-key');
        var removeRow = removeBtn.closest('[data-cart-row]');
        changeLine(removeKey, 0).then(function () {
          if (removeRow && removeRow.parentNode) removeRow.parentNode.removeChild(removeRow);
        });
      }
    });
  })();

  /* ── Carrinho lateral: steppers e remoção (delegado no documento porque
        o drawer é criado por JS depois do carregamento) ── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var drawer = e.target.closest('.cart-popup');
    if (!drawer) return;

    var qtyBtn = e.target.closest('[data-drawer-qty]');
    if (qtyBtn) {
      var step = parseInt(qtyBtn.getAttribute('data-drawer-qty'), 10) || 1;
      var row = qtyBtn.closest('[data-drawer-row]');
      var valueEl = row ? row.querySelector('[data-drawer-qty-value]') : null;
      var current = valueEl ? (parseInt(valueEl.textContent, 10) || 1) : 1;
      var next = Math.max(0, current + step);
      if (valueEl) valueEl.textContent = next;
      drawer.classList.add('is-busy');
      changeLine(qtyBtn.getAttribute('data-key'), next).then(function () {
        drawer.classList.remove('is-busy');
      }).catch(function () { drawer.classList.remove('is-busy'); });
      return;
    }

    var removeBtn = e.target.closest('[data-drawer-remove]');
    if (removeBtn) {
      drawer.classList.add('is-busy');
      changeLine(removeBtn.getAttribute('data-key'), 0).then(function () {
        drawer.classList.remove('is-busy');
      }).catch(function () { drawer.classList.remove('is-busy'); });
    }
  });

  /* ── Cupom de desconto (mesma lógica nos dois lugares) ── */
  function initDiscountForm(form) {
    if (!form || form.hasAttribute('data-discount-ready')) return;
    form.setAttribute('data-discount-ready', 'true');

    var input = form.querySelector('[data-discount-input]');
    var applyBtn = form.querySelector('[data-discount-apply]');
    var message = form.querySelector('[data-discount-message]');

    function showMessage(text, state) {
      if (!message) return;
      message.textContent = text;
      message.setAttribute('data-state', state);
      message.removeAttribute('hidden');
    }

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var code = input ? input.value.trim() : '';
        if (!code) {
          showMessage('Digite um cupom.', 'error');
          return;
        }
        var appliedList = form.querySelector('[data-discount-applied]');
        var before = appliedList ? appliedList.querySelectorAll('li').length : 0;
        applyBtn.disabled = true;
        applyDiscount(code).then(function (cart) {
          applyBtn.disabled = false;
          var after = (cart.cart_level_discount_applications || []).length;
          if (after > before) {
            showMessage('Cupom aplicado com sucesso!', 'success');
            if (input) input.value = '';
          } else {
            showMessage('Cupom inválido, expirado ou não aplicável a estes itens.', 'error');
          }
        }).catch(function () {
          applyBtn.disabled = false;
          showMessage('Não foi possível aplicar o cupom.', 'error');
        });
      });
    }

    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (applyBtn) applyBtn.click();
        }
      });
    }

    form.addEventListener('click', function (e) {
      var removeBtn = e.target.closest ? e.target.closest('[data-discount-remove]') : null;
      if (!removeBtn) return;
      applyDiscount('').then(function () {
        showMessage('Cupom removido.', 'success');
      });
    });
  }

  document.querySelectorAll('[data-discount-form]').forEach(initDiscountForm);


  /* ============================================================
     M. PDP: urgência de postagem (BRT 9h), promo timer, fragrância,
     sticky buy e notas olfativas.
  ============================================================ */
  (function initRobustaPDP() {
    function pad(n) { return String(n).padStart(2, '0'); }

    function formatRemain(ms) {
      var total = Math.max(0, Math.floor(ms / 1000));
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      return pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    /** Relógio em America/Sao_Paulo */
    function nowBRT() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false, weekday: 'short'
        }).formatToParts(new Date());
        var map = {};
        parts.forEach(function (p) { map[p.type] = p.value; });
        var wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        return {
          y: +map.year, mo: +map.month, d: +map.day,
          h: +map.hour, mi: +map.minute, s: +map.second,
          dow: wd[map.weekday] != null ? wd[map.weekday] : new Date().getDay()
        };
      } catch (e) {
        var n = new Date();
        return { y: n.getFullYear(), mo: n.getMonth() + 1, d: n.getDate(), h: n.getHours(), mi: n.getMinutes(), s: n.getSeconds(), dow: n.getDay() };
      }
    }

    /* ── Utilitários de data (independentes do fuso do navegador) ── */
    function addDays(base, days) {
      var dt = new Date(Date.UTC(base.y, base.mo - 1, base.d));
      dt.setUTCDate(dt.getUTCDate() + days);
      return { y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
    }
    function dowOf(date) {
      return new Date(Date.UTC(date.y, date.mo - 1, date.d)).getUTCDay();
    }
    function sameDate(a, b) {
      return a.y === b.y && a.mo === b.mo && a.d === b.d;
    }
    function nextBusinessDay(date) {
      var out = date;
      for (var i = 0; i < 10; i++) {
        var dw = dowOf(out);
        if (dw !== 0 && dw !== 6) return out;
        out = addDays(out, 1);
      }
      return out;
    }

    /**
     * Corte diário às 09:00 (horário de Brasília). O contador SEMPRE aponta
     * para o próximo corte, então nunca passa de 24 horas — a versão anterior
     * apontava para a segunda-feira e mostrava coisas como "69:20:28".
     *
     * Regras pedidas pelo cliente:
     *  · Dom a Qui, 09:00–23:59 ....... "amanhã pela manhã"
     *  · Seg a Sex, 00:00–08:59 ....... "hoje ainda"
     *  · Sex 09:00 até Sáb 23:59 ...... "no próximo dia útil pela manhã"
     */
    function shippingTarget(brt) {
      var beforeNine = brt.h < 9;
      var today = { y: brt.y, mo: brt.mo, d: brt.d };
      var tomorrow = addDays(today, 1);

      // Lote que ainda vai fechar: hoje 09:00 (antes das 9) ou amanhã 09:00
      var cutoffDate = beforeNine ? today : tomorrow;
      var target = { y: cutoffDate.y, mo: cutoffDate.mo, d: cutoffDate.d, h: 9, mi: 0, s: 0 };

      // A postagem só acontece em dia útil
      var postDate = nextBusinessDay(cutoffDate);

      var label;
      if (sameDate(postDate, today)) {
        label = 'hoje ainda';
      } else if (sameDate(postDate, tomorrow)) {
        label = 'amanhã pela manhã';
      } else {
        label = 'no próximo dia útil pela manhã';
      }

      return { target: target, label: label };
    }

    function brtToMs(t) {
      // Interpreta o horário BRT como instante absoluto aproximado via ISO com offset -03:00
      var iso = t.y + '-' + pad(t.mo) + '-' + pad(t.d) + 'T' + pad(t.h) + ':' + pad(t.mi) + ':' + pad(t.s) + '-03:00';
      return new Date(iso).getTime();
    }

    function tickShipping(root) {
      var countdownEl = root.querySelector('[data-urgency-countdown]');
      var whenEl = root.querySelector('[data-ship-urgency-when]');
      if (!countdownEl) return;
      var brt = nowBRT();
      var plan = shippingTarget(brt);
      if (whenEl) whenEl.textContent = plan.label;
      var remain = brtToMs(plan.target) - Date.now();
      if (remain < 0) remain = 0;
      countdownEl.textContent = formatRemain(remain);
    }

    /**
     * Cronômetro da promoção.
     * Fonte: metacampo do produto custom.promo_ends_at, entregue pelo liquid
     * como epoch em segundos (data-promo-ends-ts) — sem ambiguidade de fuso.
     * Liga sozinho quando a data é futura e é independente do preço promocional.
     * Acima de 24 h mostra "Xd HH:MM:SS".
     */
    function tickPromo(root) {
      var wrap   = root.querySelector('[data-promo-timer]');
      var val    = root.querySelector('[data-promo-countdown]');
      var sticky = root.querySelector('[data-sticky-promo]');
      if (!wrap || !val) return;

      var endMs = NaN;
      var ts = root.getAttribute('data-promo-ends-ts');
      if (ts) {
        var secs = parseInt(ts, 10);
        if (!isNaN(secs)) endMs = secs * 1000;
      }
      if (isNaN(endMs)) {
        var legacy = root.getAttribute('data-promo-ends');
        if (legacy) endMs = new Date(legacy).getTime();
      }
      if (isNaN(endMs)) return;

      var remain = endMs - Date.now();
      if (remain <= 0) {
        wrap.setAttribute('hidden', 'hidden');
        if (sticky) sticky.setAttribute('hidden', 'hidden');
        return;
      }

      var text = formatRemainLong(remain);
      wrap.removeAttribute('hidden');
      val.textContent = text;
      if (sticky) {
        sticky.removeAttribute('hidden');
        sticky.textContent = text;
      }
    }

    function formatRemainLong(ms) {
      var total = Math.max(0, Math.floor(ms / 1000));
      var days = Math.floor(total / 86400);
      var rest = total % 86400;
      var base = formatRemain(rest * 1000);
      return days > 0 ? days + 'd ' + base : base;
    }

    /**
     * Aplica a fragrância selecionada: pinta os detalhes da página com a cor
     * cadastrada no metacampo da variante e mostra as notas olfativas.
     */
    function applyFragrance(btn, root) {
      if (!btn) return;
      var color = (btn.getAttribute('data-swatch-color') || '').trim();
      var notes = (btn.getAttribute('data-scent-notes') || '').trim();

      if (color) {
        root.style.setProperty('--fragrance-accent', color);
        document.documentElement.style.setProperty('--fragrance-accent', color);
        root.classList.add('has-fragrance-accent');
      }

      var notesEl = root.querySelector('[data-fragrance-notes]');
      var notesText = root.querySelector('[data-fragrance-notes-text]');
      if (notesEl) {
        if (notes) {
          if (notesText) { notesText.textContent = notes; }
          else { notesEl.textContent = notes; }
          notesEl.removeAttribute('hidden');
        } else {
          notesEl.setAttribute('hidden', 'hidden');
          if (notesText) notesText.textContent = '';
        }
      }
    }

    /* Notas olfativas: só o rótulo + ícone de info; o texto abre ao clicar */
    function initFragranceNotesToggle(root) {
      var toggle = root.querySelector('[data-fragrance-notes-toggle]');
      var body = root.querySelector('[data-fragrance-notes-body]');
      if (!toggle || !body) return;
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        if (open) body.setAttribute('hidden', 'hidden');
        else body.removeAttribute('hidden');
      });
    }

    function initStickyBuy(root) {
      var bar = root.querySelector('[data-sticky-buy]');
      var main = root.querySelector('[data-product-main]');
      var btn = root.querySelector('[data-sticky-buy-btn]');
      if (!bar || !main) return;

      var footer = document.querySelector('.site-footer');

      function sync() {
        var rect = main.getBoundingClientRect();
        var past = rect.bottom < 80;
        if (past) bar.removeAttribute('hidden');
        else bar.setAttribute('hidden', 'hidden');

        // O balão é fixed: some quando o rodapé entra na tela, senão fica
        // por cima do conteúdo dele (principalmente das formas de pagamento).
        if (footer) {
          var fRect = footer.getBoundingClientRect();
          bar.classList.toggle('is-near-footer', fRect.top < window.innerHeight - 24);
        }
      }
      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      if (btn) {
        btn.addEventListener('click', function () {
          var form = root.querySelector('[data-product-form]');
          if (form) {
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        });
      }
    }

    function enhanceVariantClicks(root) {
      root.querySelectorAll('.product-variant').forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyFragrance(btn, root);
          // sync sticky price after theme.js updates [data-price]
          window.setTimeout(function () {
            var price = root.querySelector('[data-price]');
            var stickyPrice = root.querySelector('[data-sticky-price]');
            if (price && stickyPrice) stickyPrice.textContent = price.textContent;
          }, 30);
        });
      });
      var active = root.querySelector('.product-variant.is-active');
      if (active) applyFragrance(active, root);
    }

    function boot() {
      var root = document.querySelector('[data-product-page]');
      if (!root) return;
      tickShipping(root);
      tickPromo(root);
      window.setInterval(function () {
        tickShipping(root);
        tickPromo(root);
      }, 1000);
      enhanceVariantClicks(root);
      initFragranceNotesToggle(root);
      initStickyBuy(root);
    }

    window.RobustaPDP = {
      boot: boot,
      tickShipping: tickShipping,
      tickPromo: tickPromo
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

})();
